import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { queryVenues } from "supabase/venues";

type UseQueryVenueParams = {
  name?: string;
  page?: number;
  perPage?: number;
};

export const useQueryVenues = (params: UseQueryVenueParams) => {
  const { name, page, perPage } = params;

  const { isLoading, isError, error, data } = useQuery({
    queryKey: ["venues", { name, page }],
    queryFn: () => {
      return queryVenues({
        name,
        page,
        perPage,
      });
    },
    placeholderData: keepPreviousData,
  });

  return {
    isLoading,
    isError,
    error,
    count: data?.count,
    venues: data?.venues,
  };
};
